import PropTypes from 'prop-types';

import Text from '../typography/text';
import * as style from './DonationCount.module.scss';

const DonationCount = ({ count, text }) => {
  return (
    <div className={style.donationCount}>
      <div className={style.numbers}>
        {count
          .toString()
          .replace(/\B(?=(\d{3})+(?!\d))/g, ',')
          .split('')
          .map((letter, index) => (
            <Text as="span" className={style.number} key={`${letter}-${index}`}>
              {letter}
            </Text>
          ))}
      </div>
      <div className={style.text}>{text}</div>
    </div>
  );
};

DonationCount.propTypes = {
  count: PropTypes.number.isRequired,
  text: PropTypes.string.isRequired,
};

export default DonationCount;
